import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { bool } from "prop-types";
import { Link } from "react-router-dom";
import GridTable from "pages/_components/GridTable/GridTable";
import ProductList from "pages/_components/product/List";
import Drawer from "pages/_components/Drawer/Drawer";
import { discountsOptions } from "util/discounts";
import EmptyScreenAlert from "pages/_components/EmptyScreenAlert/EmptyScreenAlert";
import Compose from "pages/discounts/DisccountShare/Compose";
import { push } from "connected-react-router";
import TitleColumns from "./components/TitleColumns";
import VendorDiscountsItem from "./components/ItemRow";
import FilterTags from "../_components/FilterTags";
import useDiscountFilters from "./hooks/useDiscountFilters";
import FilterForm from "./components/FilterForm";
import SideBar from "../_components/SideBar";

const DiscountsTable = ({ isDesktop }) => {
    const [openSidebar, setOpenSidebar] = useState(false);
    const [actionDrawer, setActionDrawer] = useState({ showDrawer: false, contentDrawer: null });
    const { fetching, transactionsEcheqDiscount } = useSelector((_state) => _state.discounts);
    const { tags, handleDelete, handleCleanFilters, setFilters } = useDiscountFilters(discountsOptions[0]);
    const [tid, setTid] = useState(null);
    const row = isDesktop ? 1 : 4;
    const dispatch = useDispatch();
    const [showDrawer, setShowDrawer] = useState(false);

    const openSideBarFilters = () => {
        setOpenSidebar(true);
    };

    const handleCloseActionDrawer = () => {
        setActionDrawer({ showDrawer: false, contentDrawer: null, title: "" });
    };

    const showShareDrawer = (transactionId) => {
        setShowDrawer(true);
        setTid(transactionId);
    };

    const goToTicket = (transactionId) => {
        dispatch(push(`/transaction/${transactionId}`));
    };

    const DestinationInfo = () => (
        <Drawer className="help-slider" openSidebar={showDrawer} toggleSidebar={() => setShowDrawer(false)}>
            <div className="container">
                <Compose idTransaction={tid} />
            </div>
        </Drawer>
    );

    return (
        <div className="container">
            <FilterTags
                tags={tags}
                handleDelete={handleDelete}
                handleCleanFilters={handleCleanFilters}
                openSideBarFilters={openSideBarFilters}
            />
            <DestinationInfo />
            {transactionsEcheqDiscount?.length ? (
                <>
                    <ProductList
                        fetchingWithPreviousData
                        fetching={fetching}
                        items={transactionsEcheqDiscount || []}
                        noDataText="global.no.results"
                        noFiltersDataText="debin.global.no.results"
                        renderItem={(item) => (
                            <GridTable.Container
                                key={`providers-ThirdPayment-item-${item?.idTransaction}`}
                                renderAs={Link}
                                to={`/Discounts/providers/detail/${item?.idTransaction}`}
                                className={!isDesktop && "box box-shadow"}>
                                <VendorDiscountsItem
                                    key={`transaction-${item?.idTransaction}`}
                                    transactionsEcheqDiscount={item}
                                    setDrawer={setActionDrawer}
                                    isDesktop={isDesktop}
                                    showShareDrawer={showShareDrawer}
                                    goToTicket={goToTicket}
                                />
                            </GridTable.Container>
                        )}>
                        {(listItem) => (
                            <GridTable className="discounts-table">
                                <GridTable.Header>
                                    <GridTable.Container rows={row}>
                                        <TitleColumns />
                                    </GridTable.Container>
                                </GridTable.Header>
                                <GridTable.Body>{listItem}</GridTable.Body>
                            </GridTable>
                        )}
                    </ProductList>
                </>
            ) : (
                <EmptyScreenAlert message="echeks.service.noPending" showLoader={fetching} />
            )}
            <SideBar isDesktop={isDesktop} openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <FilterForm setFilters={setFilters} setOpenSidebar={setOpenSidebar} />
            </SideBar>
            <Drawer openSidebar={actionDrawer.showDrawer} onClose={handleCloseActionDrawer}>
                {actionDrawer.contentDrawer}
            </Drawer>
        </div>
    );
};

DiscountsTable.propTypes = {
    isDesktop: bool.isRequired,
};

export default DiscountsTable;
